import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DownloadStatus = 'downloading' | 'paused' | 'completed' | 'error';

interface DownloadFile {
  id: string;
  name: string;
  url: string;
  progress: number;
  status: DownloadStatus;
}

interface DownloadState {
  downloadingFiles: DownloadFile[];
}

const initialState: DownloadState = {
  downloadingFiles: [],
};

const downloadSlice = createSlice({
  name: 'download',
  initialState,
  reducers: {
    addDownload: (state, action: PayloadAction<DownloadFile>) => {
      state.downloadingFiles.push(action.payload);
    },
    addDownloads: (state, action: PayloadAction<DownloadFile[]>) => {
      state.downloadingFiles.push(...action.payload);
    },
    updateProgress: (
      state,
      action: PayloadAction<{ id: string; progress: number }>
    ) => {
      const file = state.downloadingFiles.find(f => f.id === action.payload.id);
      if (file) {
        file.progress = action.payload.progress;
      }
    },
    setStatus: (
      state,
      action: PayloadAction<{ id: string; status: DownloadStatus }>
    ) => {
      const file = state.downloadingFiles.find(f => f.id === action.payload.id);
      if (file) {
        file.status = action.payload.status;
      }
    },
    removeDownload: (state, action: PayloadAction<string>) => {
      state.downloadingFiles = state.downloadingFiles.filter(
        f => f.id !== action.payload
      );
    },
    clearAllDownloads: state => {
      state.downloadingFiles = [];
    },
  },
});

export const {
  addDownload,
  addDownloads,
  updateProgress,
  setStatus,
  removeDownload,
  clearAllDownloads,
} = downloadSlice.actions;

export default downloadSlice.reducer;
